import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import heroBg1 from '../../assets/images/hero_bg_new1.jpg';
import heroBg2 from '../../assets/images/hero_bg_new2.jpg';

const Hero = () => {
  const [currentBg, setCurrentBg] = useState(heroBg1);
  const [fade, setFade] = useState(false);
  const [letters, setLetters] = useState<string[]>([]);

  const fullText = 'ADVISERS';

  // Background transition effect
  useEffect(() => {
    const backgrounds = [heroBg1, heroBg2];
    let index = 0;

    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        index = (index + 1) % backgrounds.length;
        setCurrentBg(backgrounds[index]);
        setFade(false);
      }, 800);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Split text into letters for animation
  useEffect(() => {
    setLetters(fullText.split(''));
  }, []);



  return (
    <section
      className={`hero ${fade ? 'fade' : ''}`}
      id="home"
      style={{ backgroundImage: `url(${(currentBg as any).default || currentBg})` }}
    >
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">
            LEADING LAW FIRM IN COIMBATORE, INDIA

          </h1>
          <p className="hero-subtitle-gold">We aim to deliver exceptional yet affordable legal services like civil law,
            property law, consumer law, arbitration law, criminal law, debt recovery tribunal and chit-fund cases.</p>
          <Link className="btn btn-primary" to="/contact" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <b>Schedule a Consultation</b>
          </Link>
        </div>
      </div>

      {/* Animated bottom text */}
      <div className="hero-bottom-text">
        {letters.map((letter, index) => (
          <span
            key={index}
            className="animated-letter"
            style={{ animationDelay: `${index * 0.08}s` }}
          >
            {letter === ' ' ? '\u00A0' : letter}
          </span>
        ))}
      </div>
    </section>
  );
};

export default Hero;
